export const subscriptionType = {
  EXHIBITOR: 'exhibitor',
  AFFILIATE: 'affiliate',
};

export const subscriptionEvent = {
  ASIA: 'asia',
  EUROPE: 'europe',
};

export const ticketTypes = {
  AFFILIATE: 'affiliate',
  COMPANY: 'company',
  SWC: 'swc-affiliate-pass-ticket',
  ECML_TICKET: 'ecommerce-mastery-live',
  FBML_TICKET: 'facebook-mastery-live',
  ECML_AND_FBML_BUNDLE_TICKET: 'ecml-and-fbml-bundle-ticket',
};

export const sponsorshipFilters = {
  AVAILABLE: 'available',
  PRICE_LOW: 'price-low',
  PRICE_HIGH: 'price-high',
};

export const sponsorshipSlugs = {
  WATER: 'sponsor-water',
  STAGE_BRANDING: 'sponsor-stage-branding',
  PANEL_SLOT: 'sponsor-panel-slot',
  SPEECH: 'sponsor-speech',
  BEER_GARDEN: 'sponsor-beer-garden',
  MASSAGE: 'sponsor-massage',
  COFFEE: 'sponsor-coffee',
  WIFI: 'sponsor-wifi',
  PHOTO_BOOTH: 'sponsor-photo-booth',
  GAMING_BOOTH: 'sponsor-gaming-booth',
  BUSINESS_HUB: 'sponsor-business-hub',
  RECHARGE: 'sponsor-recharge',
  PROFILE_PHOTO: 'sponsor-profile-photo',
  NETWORKING_DRINKS: 'sponsor-networking-drinks',
  OFFICIAL_PARTNER: 'sponsor-official-affiliate-world-partner',
  HOTEL: 'sponsor-hotel',
  STAGE: 'sponsor-stage-branding',
  OFFICIAL_BAR: 'sponsor-official-bar',
};

export const boothStatus = {
  AVAILABLE: 'available',
  RESERVED: 'reserved',
  IN_CART: 'in_cart',
  PURCHASED: 'purchased',
};

export const boothTypes = {
  DIAMOND: 'diamond-booth',
  PREMIUM: 'premium-booth',
  CLASSIC: 'classic-booth',
  BASIC: 'basic-booth',
};

export const cartTypes = {
  BOOTH: 'booth',
  SPONSORSHIP: 'sponsorship',
  TICKETS: 'tickets',
};

export const sponsorshipType = {
  DIAMOND: 'diamond-partnership',
  NETWORKING: 'networking-sponsorship',
  BOOSTER: 'booster-sponsorship',
};

export const lineItemType = {
  DEFAULT: 'not-applicable',
  BOOTH: 'booth',
  NETWORKING: 'networking',
  DIAMOND: 'diamond',
  BOOSTER: 'booster',
};

export const sponsorshipTiers = {
  SILVER: 'silver',
  GOLD: 'gold',
  DIAMOND: 'diamond',
};

export const cartStatus = {
  ACTIVE: 'active',
  COMPLETED: 'completed',
  ABANDONED: 'abandoned',
  INVALIDATED: 'invalidated',
  CHECKED_OUT: 'checked_out',
};

export const globalSettings = {
  SPONSORSHIP_EXPIRY: 'sponsorship_expiry',
  BOOTH_EXPIRY: 'booth_expiry',
  SPONSORSHIP_EXPIRY_WARNING: 'sponsorship_expiry_warning',
  BOOTH_EXPIRY_WARNING: 'booth_expiry_warning',
};

export const companyPasses = {
  diamond: 10,
  super: 6,
  premium: 6,
  classic: 4,
  basic: 2,
  networking: 4,
  booster: 4,
};

export const SPONSOR_BOOTHS = ['A35', 'A36', 'A49', 'A57', 'A58', 'A70', 'A79', 'B23', 'C16', 'C28', 'C40', 'C52', 'C63', 'C65', 'B01', 'B23', 'B13', 'B15', 'B17', 'B19'];

export const SPONSOR_PREMIUM_BOOTHS = ['B01', 'B23', 'B13', 'B15', 'B17', 'B19'];

export const BOOSTER_SPONSOR_BOOTHS = ['A35', 'A36', 'A49', 'A57', 'A58', 'A70', 'A79', 'C16', 'C28', 'C40', 'C52', 'C63', 'C65', 'B01', 'B23'];

export const DIAMOND_SPONSOR_BOOTHS = ['B13', 'B15', 'B17', 'B19'];

export const floorplan = {
  SVG: '//awc-assets.imgix.net/floorplan-awa19.svg?v=1',
  BG: '//awc-assets.imgix.net/floorplan-awa19-bg.jpg?v=1',
};



// WEBPACK FOOTER //
// ./src/common/constants.js